import Vue from 'vue';

const mutations = {
  addConstraint(state, { interactionId, constraintNames }) {
    if (state.waitingForEvent[interactionId]) {
      state.waitingForEvent[interactionId] = [...state.waitingForEvent[interactionId], ...constraintNames];
    } else {
      state.waitingForEvent[interactionId] = constraintNames;
    }
    state.waitingForEvent = structuredClone(state.waitingForEvent);
  },

  removeConstraint(state, { interactionId, constraintNames }) {
    if (state.waitingForEvent[interactionId]) {
      state.waitingForEvent[interactionId] = state.waitingForEvent[interactionId].filter(
        constraint => !constraintNames.includes(constraint)
      );
      if (state.waitingForEvent[interactionId].length === 0) {
        delete state.waitingForEvent[interactionId];
      }
      state.waitingForEvent = structuredClone(state.waitingForEvent);
    }
  },

  clearConstraint(state, { interactionId }) {
    if (state.waitingForEvent[interactionId]) {
      delete state.waitingForEvent[interactionId];
      state.waitingForEvent = structuredClone(state.waitingForEvent);
    }
  },

  clearAllConstraints(state) {
    state.waitingForEvent = {};
  },

  addAgentStateConstraint(state, { agentId }) {
    state.customEvents.agentState.push(agentId);
    state.customEvents = structuredClone(state.customEvents);
  },

  removeEventTimingConstraintForAgentState(state, { agentId }) {
    state.customEvents.agentState = state.customEvents.agentState.filter(id => id !== agentId);
    state.customEvents = structuredClone(state.customEvents);
  },

  addAgentTerminalConstraint(state, { agentId, timeout, timedOutAction }) {
    state.customEvents.agentTerminal.push(agentId);
    state.customEvents = structuredClone(state.customEvents);
    if (timeout && timedOutAction) {
      setTimeout(() => {
        const count = state.customEvents.agentTerminal.length;
        state.customEvents.agentTerminal = state.customEvents.agentTerminal.filter(id => id !== agentId);
        state.customEvents = structuredClone(state.customEvents);
        if (count !== state.customEvents.agentTerminal.length) {
          timedOutAction();
        }
      }, timeout);
    }
  },

  removeEventTimingConstraintForAgentTerminal(state, { agentId }) {
    state.customEvents.agentTerminal = state.customEvents.agentTerminal.filter(id => id !== agentId);
    state.customEvents = structuredClone(state.customEvents);
  },

  addKPICounterConstraint(state, { counterTypeId, handlerId }) {
    if (!state.customEvents.kpiCounter[counterTypeId]) {
      // eslint-disable-next-line import/no-named-as-default-member
      Vue.set(state.customEvents.kpiCounter, counterTypeId, {});
    }
    if (!state.customEvents.kpiCounter[counterTypeId][handlerId]) {
      // eslint-disable-next-line import/no-named-as-default-member
      Vue.set(state.customEvents.kpiCounter[counterTypeId], handlerId, true);
    }
  },

  removeKPICounterConstraint(state, { counterTypeId, handlerId }) {
    if (state.customEvents.kpiCounter[counterTypeId]) {
      if (state.customEvents.kpiCounter[counterTypeId][handlerId]) {
        Vue.delete(state.customEvents.kpiCounter[counterTypeId], handlerId);
        if (Object.keys(state.customEvents.kpiCounter[counterTypeId]).length === 0) {
          Vue.delete(state.customEvents.kpiCounter, counterTypeId);
        }
      }
    }
  },

  removeAllEventTimingConstraints(state) {
    // eslint-disable-next-line import/no-named-as-default-member
    Vue.set(state.customEvents, 'kpiCounter', {});
  },

  queueInteractionEventCallback(state, { interactionId, eventName, callback }) {
    if (!state.queuedCallbacks.interaction[interactionId]) {
      // eslint-disable-next-line import/no-named-as-default-member
      Vue.set(state.queuedCallbacks.interaction, interactionId, {});
    }
    if (!state.queuedCallbacks.interaction[interactionId][eventName]) {
      // eslint-disable-next-line import/no-named-as-default-member
      Vue.set(state.queuedCallbacks.interaction[interactionId], eventName, callback);
    }
  },

  queueElementEventCallback(state, { elementId, eventName, callback }) {
    if (!state.queuedCallbacks.element[elementId]) {
      // eslint-disable-next-line import/no-named-as-default-member
      Vue.set(state.queuedCallbacks.element, elementId, {});
    }
    if (!state.queuedCallbacks.element[elementId][eventName]) {
      // eslint-disable-next-line import/no-named-as-default-member
      Vue.set(state.queuedCallbacks.element[elementId], eventName, callback);
    }
  },

  removeInteractionEventCallback(state, { interactionId, eventName }) {
    if (state.queuedCallbacks.interaction[interactionId]) {
      if (state.queuedCallbacks.interaction[interactionId][eventName]) {
        Vue.delete(state.queuedCallbacks.interaction[interactionId], eventName);
        if (Object.keys(state.queuedCallbacks.interaction[interactionId]).length === 0) {
          Vue.delete(state.queuedCallbacks.interaction, interactionId);
        }
      }
    }
  },

  removeElementEventCallback(state, { elementId, eventName }) {
    if (state.queuedCallbacks.element[elementId]) {
      if (state.queuedCallbacks.element[elementId][eventName]) {
        state.queuedCallbacks.element[elementId][eventName]();
        Vue.delete(state.queuedCallbacks.element[elementId], eventName);
        if (Object.keys(state.queuedCallbacks.element[elementId]).length === 0) {
          Vue.delete(state.queuedCallbacks.element, elementId);
        }
      }
    }
  }
};

export default {
  ...mutations
};
